import React, { CSSProperties, HTMLAttributes } from 'react';
import { Card as MuiCard } from '@mui/material';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
    children?: React.ReactNode;
    className?: string;
    style?: CSSProperties;
}

const Card = (props: CardProps) => {
    const { children, ...restProps } = props;
    return <MuiCard {...restProps}>{children}</MuiCard>;
};

export default Card;
